<template>
  <div id="lang_screen" class="w-full h-90vh fixed top-0 left-0">
    <background-red-concrete class="min-h-screen">
      <button @click="closeSwitcher" class="absolute right-0 top-0 px-8 py-3 m-6 md:m-12 transform scale-150">
        <i class="gg-close text-white"></i>
      </button>

      <img alt="Mascot" src="/uploads/cable_monkey.png" class="mx-auto h-48 sm:h-64 menu-ape relative" />

      <div
        class="relative mx-auto h-full justify-center w-full md:w-3/4 flex flex-col sm:flex-row flex-wrap sm:flex-no-wrap mt-4 sm:mt-0"
      >
        <div
          v-for="exhibit of $t('menu_exhibits')"
          :key="exhibit.id"
          class="mx-8 flex sm:block py-4 sm:py-0 border-0 border-t sm:border-t-0 border-white border-opacity-50 flex-1"
          :class="exhibit.id === Object.keys($t('menu_exhibits')).length ? 'border-b sm:border-b-0' : ''"
        >
          <router-link
            class="flex sm:block"
            :to="$t(exhibit.link)"
            v-on:click.native="closeSwitcher(exhibit.link)"
            replace
          >
            <img class="hidden sm:block" :alt="exhibit.alt" :src="`/uploads/exhibit_${exhibit.id}.png`" />
            <img class="sm:hidden mr-8 mobile-outlet" alt="Power Outlet" :src="`/uploads/power_outlet.png`" />
            <p class="mt-4 sm:mt-8 text-left sm:text-center text-white text-sm md:text-base mobile-text">
              {{ exhibit.title }}
            </p>
          </router-link>
        </div>
      </div>

      <div
        class="mx-auto justify-center w-full flex flex-row absolute bottom-0 h-20 sm:h-48 languages-row"
        :class="$device.android || $device.ios ? 'mb-24' : ''"
      >
        <button
          v-for="lang of languages"
          :key="lang.langShort"
          @click="switchLanguageTo(lang.langShort)"
          class="outline-none focus:outline-none text-white text-xl md:text-3xl font-bold uppercase mx-4"
          :class="{ underline: activeLang === lang.langShort }"
        >
          {{ lang.langLong }}
        </button>
      </div>
    </background-red-concrete>
  </div>
</template>

<script>
import { gsap } from "gsap";
import BackgroundRedConcrete from "../section-backgrounds/RedConcrete";
import { getOtherDomain } from "../../domains";
export default {
  components: {
    BackgroundRedConcrete,
  },

  mounted() {
    this.$emit("onOpen");
    gsap.from("#lang_screen", { opacity: "0", scale: "1.05", ease: "power4.out", duration: 1 });
  },
  computed: {
    languages() {
      return Object.values(this.$i18n.messages);
    },
    activeLang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    switchLanguageTo(lang) {
      const currentPath = this.$route.fullPath;
      this.$i18n.locale = lang;
      window.open(`${getOtherDomain(lang)}${currentPath}`, "_self");
      this.closeSwitcher();
    },

    toTop() {
      if (this.$device.ios || this.$device.android) {
        let beginning = document.getElementById("sound_section");
        beginning.scrollIntoView({ behavior: "smooth" });
      } else {
        window.scrollTo(0, 0);
      }
    },
    closeSwitcher(link) {
      if (link === this.$route.path) {
        this.toTop();
      }

      this.$emit("onClose");
      gsap.to("#lang_screen", {
        scale: "1.1",
        ease: "power4.out",
        opacity: "0",
        duration: 1,
        delay: 0.2,
        onComplete: this.reallyCloseSwitcher,
      });
    },
    reallyCloseSwitcher() {
      this.$store.commit("closeLanguageSwitcher");
    },
  },
};
</script>

<style lang="postcss" scoped>
.h-90vh {
  height: 90vh;
}

#lang_screen {
  z-index: 3000;
}

@media screen and (max-height: 800px) {
  .mobile-outlet {
    width: 75px;
    height: 75px;
  }
}

@media screen and (max-height: 700px) {
  .mobile-outlet {
    width: 55px;
    height: 55px;
  }
}

@media screen and (max-height: 600px) {
  .mobile-outlet {
    width: 30px;
    height: 30px;
  }
}

@media (max-height: 1000px) and (max-width: 600px) {
  .mobile-text {
    margin-top: 40px;
  }
}

@media (max-height: 800px) and (max-width: 600px) {
  .mobile-text {
    margin-top: 25px;
  }
}

@media (max-height: 700px) and (max-width: 600px) {
  .mobile-text {
    margin-top: 20px;
  }
}

@media (max-height: 600px) and (max-width: 600px) {
  .mobile-text {
    margin-top: 5px;
  }
}

@media screen and (max-height: 450px) {
  .menu-ape {
    height: 30vh;
  }
  .languages-row {
    height: 50px;
    bottom: 0px;
    position: absolute;
    margin-bottom: 1rem;
  }
}

.mobile-text {
}

.mobile-outlet {
}
</style>
